'use strict';
var LazyLoad = global.LazyLoad = require('vanilla-lazyload/dist/lazyload');

module.exports = {
    init: function () {
        var lazyLoadInstance = new LazyLoad({
            elements_selector: '.lazy',
            use_native: true,
            load_delay: 200
        });
        // Update the instance
        if (lazyLoadInstance) {
            lazyLoadInstance.update();
        }
    }
};
